import {useMutation, useQueryClient} from '@tanstack/react-query';
import {directoryService} from '../services/directory';
import {message} from 'antd';

export function useMove(currentId?: number | string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: any) => {
      if(!currentId) {
        throw new Error('缺少 currentId');
      }

      return directoryService.move(params)
    },

    onSuccess: (_res:any) => {
      void message.success(_res || '移动成功');

      void queryClient.invalidateQueries({
        queryKey: ['file-list']
      });
    },

    onError: () => {
      void message.error('移动失败');
    }
  });
}